import { toast } from "react-toastify";
import { LS_USER } from "constants/key";
import * as ls from "utils/localStorage";

export default function errorHandler(error) {
  if (error) {
    let message;
    if (error.response) {
      if (error.response.status === 401){
        setTimeout(function () {
          ls.remove(LS_USER);
          ls.set("logout", Date.now().toString());
    
          document.location.href = "/";
        }, 3000);

        //return Promise.reject(error);

        return Promise.reject({
          message: "Session expired. Please login again"
        });
      }

      if (error.response.status === 500) message = "Something went wrong";
      else message = error.response.data.message;

      if (typeof message === "string") toast.error(message);

      return Promise.reject(error);
    }
  }
}
